import styled from '@emotion/styled';

export const ErrorMessage = styled.p`
    color: ${({ theme }): string => theme.base.color.bloodyMary};
    text-align: center;
`;
